module.exports = __webpack_public_path__ + "media/Closer_(Live)_-_Josie_Buchanan__Bethel_Music(256k).4330799a.mp3";